import mobile4 from "../../assets/BestInCate/btcMobile4.jpeg";
import iphone17 from "../../assets/BestInCate/iphone17.png";
import iphone17Pro from "../../assets/BestInCate/iphone17pro.png";
import iphoneAir from "../../assets/apple/iPhoneAir/iPhoneAir1.png";

import w1 from "../../assets/BestInCate/BestInCatWatch/Watch1.png";
import watch2 from "../../assets/BestInCate/BestInCatWatch/Watch2.png";
import watch3 from "../../assets/BestInCate/BestInCatWatch/Watch3.png";
import watch4 from "../../assets/BestInCate/BestInCatWatch/Watch4.png";
import watch5 from "../../assets/BestInCate/BestInCatWatch/Watch5.png";

import speaker1 from "../../assets/BestInCate/speaker1.jpeg";
import speaker2 from "../../assets/BestInCate/speaker2.jpeg";
import speaker3 from "../../assets/BestInCate/speaker3.jpeg";
import speaker4 from "../../assets/BestInCate/speaker4.jpeg";
import speaker5 from "../../assets/BestInCate/speaker5.jpeg";

import earphone1 from "../../assets/BestInCate/earphone1.jpeg";
import earphone2 from "../../assets/BestInCate/earphone2.jpeg";
import earphone3 from "../../assets/BestInCate/earphone3.jpeg";
import earphone4 from "../../assets/BestInCate/earphone4.jpeg";
import earphone5 from "../../assets/BestInCate/earphone5.jpeg";

import c3 from "../../assets/BestInCate/c3.jpeg";

import iPadProM5 from "../../assets/apple/iPad/iPad2026/iPadPro/iPadPro_1.png";
import iPadAirM4 from "../../assets/apple/iPad/iPad2026/iPadAir/iPadAir01.png";
import iPadMini7Gen from "../../assets/apple/iPad/iPad2026/iPadMini/iPadMini7Gen/iPadMini7Gen.png";
import tabS10Plus from "../../assets/samsung/mix/tab_s10_plus.jpeg";
import tabA9 from "../../assets/samsung/tab_a9/tab_a9.jpeg";

const detailsData = {
  1: [
    {
      id: 1,
      name: "iPhone 17",
      extraline: "",
      mrp: "",
      EMIline: "No Cost EMI starting at ₹2,430 p/m",
      img: iphone17,
      path: "applestore/iphone-products-list/iphone-detail-page/iphone/1",
    },
    {
      id: 2,
      name: "iPhone 17 Pro",
      extraline: "",
      mrp: "",
      EMIline: "No Cost EMI starting at ₹3,997 p/m",
      img: iphone17Pro,
      path: "applestore/iphone-products-list/iphone-detail-page/iphone/2",
    },
    {
      id: 3,
      name: "iPhone 16",
      extraline: "",
      mrp: "",
      EMIline: "No Cost EMI starting at ₹1,830 p/m",
      img: c3,
      path: "applestore/iphone-products-list/iphone-detail-page/iphone/5",
    },
    {
      id: 4,
      name: "iPhone 15",
      extraline: "",
      mrp: "",
      EMIline: "No Cost EMI starting at ₹2,029 p/m",
      img: mobile4,
      path: "applestore/iphone-products-list/iphone-detail-page/iphone/8",
    },
    {
      id: 5,
      name: "iPhone Air",
      extraline: "Effective Price - Rs. 91,900",
      mrp: "",
      EMIline: "Includes store discount, Axis/ICICI EMI cashback and exchange bonus",
      highlightPrice: true,
      img: iphoneAir,
      path: "/applestore/iphone-products-list/iphone-detail-page/iphone/4",
    },
  ],
  2: [
    {
      id: 1,
      name: "Apple Watch Ultra 3",
      extraline: "Titanium Case with Milanese Loop",
      mrp: "M.R.P. Rs. 1,04,900",
      EMIline: "",
      img: w1,
      path: "applestore/iphone-products-list/iphone-detail-page/applewatch/6",
    },
    {
      id: 2,
      name: "Series 11",
      extraline: "Titanium Case with Milanese Loop",
      mrp: "M.R.P. Rs. 84,900",
      EMIline: "",
      img: watch2,
      path: "applestore/iphone-products-list/iphone-detail-page/applewatch/7",
    },
    {
      id: 3,
      name: "Series 11",
      extraline: "Aluminum Case in Jet Black",
      mrp: "M.R.P. Rs. 46,900",
      EMIline: "",
      img: watch3,
      path: "applestore/iphone-products-list/iphone-detail-page/applewatch/5",
    },
    {
      id: 4,
      name: "Series 11",
      extraline: "Aluminum Case in Silver",
      mrp: "M.R.P. Rs. 46,900",
      EMIline: "",
      img: watch4,
      path: "applestore/iphone-products-list/iphone-detail-page/applewatch/5",
    },
    {
      id: 5,
      name: "SE 3rd Gen.",
      extraline: "Aluminum Case in Midnight",
      mrp: "M.R.P. Rs. 25,900",
      EMIline: "",
      img: watch5,
      path: "applestore/iphone-products-list/iphone-detail-page/applewatch/1",
    },
  ],
  3: [
    {
      id: 1,
      name: "Marshall Woburn lll",
      extraline: "",
      mrp: "M.R.P. ₹59,999",
      EMIline: "",
      img: speaker1,
      path: "/accessories?product=marshall-s-7",
    },
    {
      id: 2,
      name: "Marshall Tufton",
      extraline: "",
      mrp: "M.R.P. ₹39,999",
      EMIline: "",
      img: speaker2,
      path: "/accessories?product=marshall-s-3",
    },
    {
      id: 3,
      name: "Marshall Stanmore lll",
      extraline: "",
      mrp: "M.R.P ₹41,999",
      EMIline: "",
      img: speaker3,
      path: "/accessories?product=marshall-s-8",
    },
    {
      id: 4,
      name: "Marshall Kilburn ll",
      extraline: "",
      mrp: "M.R.P. ₹27,999",
      EMIline: "",
      img: speaker4,
      path: "/accessories?product=marshall-s-6",
    },
    {
      id: 5,
      name: "Marshall Emberton ll",
      extraline: "",
      mrp: "M.R.P. ₹19,999",
      EMIline: "",
      img: speaker5,
      path: "/accessories?product=marshall-s-2",
    },
  ],

  6: [
    {
      id: 1,
      name: "AirPods Pro",
      extraline: "",
      mrp: "",
      EMIline: "No Cost EMI at ₹4,150* p/m",
      img: earphone1,
      path: "applestore/products-list/airpods",
    },
    {
      id: 2,
      name: "AirPods",
      extraline: "",
      mrp: "",
      EMIline: "No Cost EMI at ₹2,150* p/m",
      img: earphone2,
      path: "applestore/products-list/airpods",
    },
    {
      id: 3,
      name: "Marshall Major lV",
      extraline: "",
      mrp: "M.R.P. ₹12,999",
      EMIline: "",
      img: earphone3,
      path: "/accessories?product=marshall-h-4",
    },
    {
      id: 4,
      name: "Marshall Minor lll",
      extraline: "",
      mrp: "M.R.P. ₹19,999",
      EMIline: "",
      img: earphone4,
      path: "/accessories?product=marshall-h-5",
    },
    {
      id: 5,
      name: "Marshall Motif ll",
      extraline: "",
      mrp: "M.R.P. ₹19,999",
      EMIline: "",
      img: earphone5,
      path: "/accessories?product=marshall-h-7",
    },
  ],
  4: [
    {
      id: 1,
      name: "iPad Pro 13-inch",
      extraline: "M5 (Wi-Fi + Cellular)",
      mrp: "₹1,49,900",
      EMIline: "No Cost EMI Available",
      img: iPadProM5,
      path: "/applestore/iphone-products-list/iphone-detail-page/ipad/10",
    },
    {
      id: 2,
      name: "iPad Air 13-inch",
      extraline: "M4 (Wi-Fi + Cellular)",
      mrp: "₹99,900",
      EMIline: "No Cost EMI Available",
      img: iPadAirM4,
      path: "/applestore/iphone-products-list/iphone-detail-page/ipad/14",
    },
    {
      id: 3,
      name: "Galaxy Tab S10 Plus",
      extraline: "12.4-inch Display",
      mrp: "",
      EMIline: "Get exclusive upgrade or credit card offers",
      img: tabS10Plus,
      path: "applestore/iphone-products-list/iphone-detail-page/galaxyTab/2",
    },
    {
      id: 4,
      name: "iPad Mini 7 Gen",
      extraline: "Wi-Fi 128GB",
      mrp: "₹49,900",
      EMIline: "No Cost EMI Available",
      img: iPadMini7Gen,
      path: "/applestore/iphone-products-list/iphone-detail-page/ipad/17",
    },
    {
      id: 5,
      name: "Galaxy Tab A9",
      extraline: "8.7-inch Display",
      mrp: "",
      EMIline: "Get exclusive upgrade or credit card offers",
      img: tabA9,
      path: "applestore/iphone-products-list/iphone-detail-page/galaxyTab/1",
    },
  ],
};

export default detailsData;
